<template>
    <v-container class="grey lighten-5" fluid>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-card-title>
                        Edytuj oddział
                    </v-card-title>
                    <v-card-text>
                        <v-btn @click="$router.push({name: 'price-list-company-details', params: { id: companyId }})">
                            powrót do szczegółów firmy
                        </v-btn>
                        <CompanyBranchAddEdit
                            :companyId="this.companyId"
                            :id="this.id"
                        />
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
<!--        <v-row>-->
<!--            <v-col cols="12">-->
<!--                <v-card>-->
<!--                    <v-card-title>-->
<!--                        Kategorie-->
<!--                    </v-card-title>-->
<!--                    <v-card-text>-->
<!--                        <CompanyBranchCategories-->
<!--                            :companyId="this.companyId"-->
<!--                            :branchId="this.id"-->
<!--                            :reloadCompanyBranchData="reloadData"-->
<!--                        />-->
<!--                    </v-card-text>-->
<!--                </v-card>-->
<!--            </v-col>-->
<!--        </v-row>-->
        <v-row>
            <v-col cols="12">
                <v-expansion-panels>
                    <v-expansion-panel>
                        <v-expansion-panel-header style="font-size: 1.25rem;font-weight: 500;letter-spacing: .0125em;line-height: 2rem;">Obsługiwane miasta</v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <CompanyBranchCities
                                ref="companyBranchCities"
                                :companyId="this.companyId"
                                :branchId="this.id"
                                :excluded="false"
                                :reloadCompanyBranchData="reloadData"
                            />
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-expansion-panels>
                    <v-expansion-panel>
                        <v-expansion-panel-header style="font-size: 1.25rem;font-weight: 500;letter-spacing: .0125em;line-height: 2rem;">Wykluczone miasta</v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <CompanyBranchCities
                                ref="companyBranchCities"
                                :companyId="this.companyId"
                                :branchId="this.id"
                                :excluded="true"
                                :reloadCompanyBranchData="reloadData"
                            />
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-card-title>
                        Wymiary
                    </v-card-title>
                    <v-card-text>
                        <CompanyBranchDimensions
                            :branchId="this.id"
                            ref="companyBranchDimensions"
                        />
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-card-title>
                        Usługi
                    </v-card-title>
                    <v-card-text>
                        <CompanyServices
                            :id="this.id"
                            url-delete="/api/price-list/company-branch/{branch}/service/{id}"
                        ></CompanyServices>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">

            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import CompanyBranchAddEdit from "@/components/price-list/CompanyBranchAddEdit";
import CompanyBranchDimensions from "../../components/price-list/CompanyBranchDimensions";
import CompanyServices from "../../components/price-list/CompanyServices";
import CompanyBranchCities from "../../components/price-list/CompanyBranchCities";

export default {
    components: {
        CompanyBranchAddEdit,
        CompanyBranchDimensions,
        CompanyBranchCities,
        CompanyServices,
    },
    props: {
        companyId: {
            type: [String],
            required: true,
        },
        id: {
            type: [String],
            required: true,
        },
    },
    methods: {
        async reloadData() {
            this.$refs.companyBranchDimensions.load();
            this.$refs.companyBranchCities.load();
        }
    }
}
</script>